module.exports = __webpack_public_path__ + "img/icon-pending.53ed5f45.svg";